import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const SuccessOutline: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      aria-hidden={!title}
      focusable='false'
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d='M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.937 17.937 22.75 12 22.75C6.06293 22.75 1.25 17.937 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.937 1.25 22.75 6.06293 22.75 12Z'
        fill={fill}
      />
      <path
        d='M15.5019 8.43945C15.7858 8.18662 16.2206 8.18487 16.5068 8.44727C16.793 8.70964 16.8287 9.14256 16.6016 9.44727L16.5527 9.50684L11.0527 15.5068C10.9146 15.6575 10.721 15.7455 10.5166 15.75C10.3376 15.7539 10.1639 15.6932 10.0264 15.5811L9.96972 15.5303L7.46972 13.0303L7.41796 12.9736C7.17765 12.6791 7.19512 12.2443 7.46972 11.9697C7.74433 11.6951 8.17905 11.6777 8.47363 11.918L8.53027 11.9697L10.4756 13.915L15.4473 8.49316L15.5019 8.43945Z'
        fill={fill}
      />
    </svg>
  )
}

export default SuccessOutline
